import { render, staticRenderFns } from "./TwIpDnUpload.vue?vue&type=template&id=174ed3bc&scoped=true&"
import script from "./TwIpDnUpload.vue?vue&type=script&lang=js&"
export * from "./TwIpDnUpload.vue?vue&type=script&lang=js&"
import style0 from "./TwIpDnUpload.vue?vue&type=style&index=0&id=174ed3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174ed3bc",
  null
  
)

export default component.exports